import { connect } from 'react-redux';
import Table from '../../../components/common/Table/Table';
import { getTableSearchResults, updateTableSearchParams, clearTableSearchParams } from '../../../actions/uiElements';
import { initialSearchResultsState } from '../../../reducers/uiElements/tablesReducer';

const mapStateToProps = ({ uiElements: { tables } }, { initialSearchParams, reduxIdentifier }) => {
  if (tables[reduxIdentifier]) {
    return {
      isFetching: tables[reduxIdentifier].searchResults ? tables[reduxIdentifier].searchResults.isFetching : false,
      searchParams: tables[reduxIdentifier].searchParams,
      searchResults: tables[reduxIdentifier].searchResults,
    };
  }
  return {
    isFetching: false,
    searchParams: initialSearchParams,
    searchResults: initialSearchResultsState,
  };
};

const mapDispatchToProps = (
  dispatch,
  { endpoint, reduxIdentifier, responseObjectName = null, initialSearchParams, method, afterReloadCallback },
) => ({
  updateParamsAndGetData: async params => {
    await dispatch(updateTableSearchParams(reduxIdentifier, params, initialSearchParams));
    dispatch(getTableSearchResults(endpoint, reduxIdentifier, responseObjectName, method));
    if (afterReloadCallback && typeof afterReloadCallback === 'function') afterReloadCallback();
  },
  getData: () => {
    dispatch(getTableSearchResults(endpoint, reduxIdentifier, responseObjectName, method));
    if (afterReloadCallback && typeof afterReloadCallback === 'function') afterReloadCallback();
  },
  clearParams: () => {
    dispatch(clearTableSearchParams(reduxIdentifier, initialSearchParams));
    if (afterReloadCallback && typeof afterReloadCallback === 'function') afterReloadCallback();
  },
  updateParams: params => {
    dispatch(updateTableSearchParams(reduxIdentifier, params, initialSearchParams));
    if (afterReloadCallback && typeof afterReloadCallback === 'function') afterReloadCallback();
  },
});

const tableContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Table);

export default tableContainer;
